import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethree-overview',
  templateUrl: './homethree-overview.component.html',
  styleUrls: ['./homethree-overview.component.scss']
})
export class HomethreeOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
